import enUSAuth from './locales/en-US/auth.json';
import enUSCommon from './locales/en-US/common.json';
import enUSNavigation from './locales/en-US/navigation.json';
import enUSProfile from './locales/en-US/profile.json';
import enUSSystem from './locales/en-US/system.json';
import enUSSettings from './locales/en-US/settings.json';
import enUSInsights from './locales/en-US/insights.json';
import enUSReports from './locales/en-US/reports.json';
import enUSQuestions from './locales/en-US/questions.json';
import es419Auth from './locales/es-419/auth.json';
import es419Common from './locales/es-419/common.json';
import es419Navigation from './locales/es-419/navigation.json';
import es419Profile from './locales/es-419/profile.json';
import es419System from './locales/es-419/system.json';
import es419Settings from './locales/es-419/settings.json';
import es419Insights from './locales/es-419/insights.json';
import es419Reports from './locales/es-419/reports.json';
import es419Questions from './locales/es-419/questions.json';
import ptBRAuth from './locales/pt-BR/auth.json';
import ptBRCommon from './locales/pt-BR/common.json';
import ptBRNavigation from './locales/pt-BR/navigation.json';
import ptBRProfile from './locales/pt-BR/profile.json';
import ptBRSystem from './locales/pt-BR/system.json';
import ptBRSettings from './locales/pt-BR/settings.json';
import ptBRInsights from './locales/pt-BR/insights.json';
import ptBRReports from './locales/pt-BR/reports.json';
import ptBRQuestions from './locales/pt-BR/questions.json';
import ptPTAuth from './locales/pt-PT/auth.json';
import ptPTCommon from './locales/pt-PT/common.json';
import ptPTNavigation from './locales/pt-PT/navigation.json';
import ptPTProfile from './locales/pt-PT/profile.json';
import ptPTSystem from './locales/pt-PT/system.json';
import ptPTSettings from './locales/pt-PT/settings.json';
import ptPTInsights from './locales/pt-PT/insights.json';
import ptPTReports from './locales/pt-PT/reports.json';
import ptPTQuestions from './locales/pt-PT/questions.json';

export const I18N_NAMESPACES = ['common', 'navigation', 'auth', 'profile', 'system', 'settings', 'insights', 'reports', 'questions'] as const;

export const resources = {
  'pt-BR': { common: ptBRCommon, navigation: ptBRNavigation, auth: ptBRAuth, profile: ptBRProfile, system: ptBRSystem, settings: ptBRSettings, insights: ptBRInsights, reports: ptBRReports, questions: ptBRQuestions },
  'pt-PT': { common: ptPTCommon, navigation: ptPTNavigation, auth: ptPTAuth, profile: ptPTProfile, system: ptPTSystem, settings: ptPTSettings, insights: ptPTInsights, reports: ptPTReports, questions: ptPTQuestions },
  'es-419': { common: es419Common, navigation: es419Navigation, auth: es419Auth, profile: es419Profile, system: es419System, settings: es419Settings, insights: es419Insights, reports: es419Reports, questions: es419Questions },
  'en-US': { common: enUSCommon, navigation: enUSNavigation, auth: enUSAuth, profile: enUSProfile, system: enUSSystem, settings: enUSSettings, insights: enUSInsights, reports: enUSReports, questions: enUSQuestions },
} as const;
